module.exports = __webpack_public_path__ + "static/img/Water Resource Statistics.56f4acd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Water Resource Statistics.jpg
// module id = tokw
// module chunks = 1